import React, { memo } from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Escribís siempre "buen desempeño" y "debe mejorar" porque no conocés las alternativas técnicas', 'No sabés cómo redactar una observación que sea honesta pero no hiriente para las familias', 'Llegás al cierre de notas sin registros y tenés que escribir los informes de memoria', 'Hacés reuniones de padres sin guion y te quedás sin palabras ante una familia difícil', 'No tenés modelos de actas y cada vez que necesitás una empezás desde cero', 'Tus boletines dicen lo mismo para todos los alumnos porque no tenés variedad de frases', 'Cada cierre de período te genera la misma pregunta: "¿Cómo arranco el informe de este alumno?"'];
  return <section className="py-20 bg-black" data-id="element-228">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-229">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-230">
          <h2 className="md:text-4xl font-extrabold text-white mb-6 text-balance text-[20px]" data-id="element-231">
            ¿Cuántas veces más vas a llegar al cierre de notas sin saber qué
            escribir en los boletines?
          </h2>

          <div className="space-y-6 text-lg text-zinc-200 text-left md:text-center max-w-3xl mx-auto" data-id="element-232">
            <p className="text-[14px]" data-id="element-233">
              Querés ser un docente organizado y profesional. Pero la realidad
              es que la carga administrativa te consume el tiempo que deberías
              dedicar a enseñar. Tal vez ya intentaste copiar frases de internet
              que sonaban genéricas y vacías. Tal vez pediste ayuda a colegas
              que tampoco sabían muy bien qué escribir. Tal vez pasaste horas
              frente a la pantalla para redactar observaciones que no reflejaban
              realmente a tus alumnos. Tal vez tenés la sensación de que "los
              informes nunca quedan bien" y no entendés por qué.
            </p>
            <p data-id="element-234">
              <strong className="text-white text-[16px]" data-id="element-235">
                No es falta de vocación. Es que nadie te enseñó cómo documentar
                tu trabajo pedagógico de manera profesional.
              </strong>
            </p>
            <p className="text-[14px]" data-id="element-236">
              Buscás modelos en grupos de WhatsApp y encontrás frases copiadas
              sin criterio pedagógico. Usás las mismas 5 expresiones en todos
              los boletines porque no sabés cómo variar. Redactás los informes
              de memoria porque nunca tuviste un sistema de registro diario. Y
              seguís llegando al final de cada período con la sensación de que
              "podría haberlo hecho mejor."
            </p>
            <p className="font-bold text-white pt-4 text-[14px]" data-id="element-237">
              No es falta de conocimiento pedagógico. Es falta de un sistema.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-red-950/40 border border-red-900/60 rounded-2xl p-6 md:p-8" data-id="element-238">
          <ul className="space-y-4" data-id="element-239">
            {problems.map((problem, i) => <li key={i} className="flex items-start gap-3" data-id="element-240">
                <div className="mt-1 bg-red-500/20 p-1 rounded-full shrink-0" data-id="element-241">
                  <X className="w-4 h-4 text-red-400" data-id="element-242" />
                </div>
                <span className="text-zinc-100 font-medium text-[14px]" data-id="element-243">
                  {problem}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <div className="text-center mt-12" data-id="element-244">
          <p className="font-bold text-violet-400 text-[16px]" data-id="element-245">
            ¿Y si este fuera el último cierre de notas que enfrentás sin un
            sistema real?
          </p>
        </div>
      </div>
    </section>;
}